import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SearchResult, SearchResults } from '../models/global-search.model';


@Component({
  selector: 'app-global-search-dropdown',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './global-search-dropdown.component.html'
})
export class GlobalSearchDropdownComponent {
  @Input() results: SearchResults | null = null;
  @Input() isVisible: boolean = false;
  @Input() searchTerm: string = '';

  @Output() resultClicked = new EventEmitter<SearchResult>();

  onResultClick(result: SearchResult): void {
    this.resultClicked.emit(result);
  }

  // Helpers para el template
  hasAnyResults(): boolean {
    if (!this.results) return false;
    return this.results.totalCount > 0;
  }

  getIconClass(type: string): string {
    const map: Record<string, string> = {
      contact: 'text-blue-500',
      company: 'text-purple-500',
      deal: 'text-green-500',
      task: 'text-amber-500',
      ticket: 'text-red-500'
    };
    return map[type] ?? 'text-gray-500';
  }
}